function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var linkColorMapping = {
  default: 'link.rest',
  inverted: 'neutral.white',
  inherit: 'inherit'
};
export var linkTheme = {
  baseStyle: _ref => {
    var {
      shouldSupportEllipsis,
      color = 'default'
    } = _ref;
    return _objectSpread(_objectSpread({
      // `display: 'inline-grid'` is needed in order to support ellipsis: https://stackoverflow.com/a/71540221
      display: shouldSupportEllipsis ? 'inline-grid' : 'inline',
      textDecoration: 'underline',
      transitionProperty: 'common',
      transitionDuration: 'fast',
      transitionTimingFunction: 'ease-out',
      cursor: 'pointer',
      outline: 'none',
      color: linkColorMapping[color]
    }, shouldSupportEllipsis && {
      display: 'inline-block',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }), {}, {
      _hover: {
        color: color === 'inverted' ? 'neutral.white' : 'link.hover',
        opacity: color === 'inverted' ? 0.8 : 1
      },
      _pressed: {
        color: 'link.pressed'
      },
      _focusVisible: {
        outlineColor: color === 'inverted' ? 'focus.invert' : 'focus.focus',
        borderRadius: 'm',
        transition: 'outline-color 0.2s'
      }
    });
  },
  sizes: {
    large: {
      textStyle: 'body2'
    },
    medium: {
      textStyle: 'body3'
    },
    small: {
      textStyle: 'body4'
    },
    xsmall: {
      textStyle: 'caption1'
    }
  },
  variants: {
    standalone: {},
    inline: {
      width: 'fit-content',
      textStyle: 'inline'
    }
  }
};
//# sourceMappingURL=Link.theme.js.map